import { Button, Divider, Input, Modal, Select } from "antd";
import { useEffect, useMemo, useState } from "react";
import { toastError, toastSuccess } from "../../utils/toast";
import { apiGetIrisProviders, apiUpdateAccountIrisCurrent } from "../../api";
import { useLoading } from "../../context/LoadingContext";

interface IrisProviderItem {
    id: string;
    name: string;
    isActive: boolean;
}

export default function ModalAccountIris({ isOpen, setIsOpen, data, fetchData }: any) {
    const [accountValue, setAccountValue] = useState('')
    const [otpConfirm, setOtpConfirm] = useState('')
    const [providers, setProviders] = useState<IrisProviderItem[]>([])

    const { setIsLoading } = useLoading()

    useEffect(() => {
        if (!isOpen) return
        const fetchProviders = async () => {
            try {
                setIsLoading(true)
                const resp = await apiGetIrisProviders()
                const list: IrisProviderItem[] = resp.data?.irisProviders || []
                setProviders(list.filter(p => p.isActive))
            } catch (error) {
                console.log(error)
                toastError('Tải danh sách tài khoản IRIS thất bại')
                setProviders([])
            } finally {
                setIsLoading(false)
            }
        }
        fetchProviders()
    }, [isOpen])

    const options = useMemo(() => (
        [{ label: 'Chọn tài khoản', value: '' }].concat(
            providers.map(p => ({ label: p.name, value: p.name }))
        )
    ), [providers])

    const hasProviders = providers.length > 0

    const handleUpdate = async () => {
        if (!accountValue) {
            toastError('Vui lòng chọn tài khoản!')
            return
        }
        if (data === accountValue) {
            toastError('Vui lòng chọn tài khoản khác!')
            return
        }
        if (!otpConfirm) {
            toastError('Vui lòng nhập mã OTP xác nhận!')
            return
        }

        try {
            setIsLoading(true)
            const resp = await apiUpdateAccountIrisCurrent({
                value: accountValue,
                otpConfirm: otpConfirm,
            })
            if (resp.status === 200) {
                fetchData()
                setIsOpen(false)
                toastSuccess('Cập nhật tài khoản IRIS thành công')
                setOtpConfirm('')
                setAccountValue('')
            }
        } catch (error) {
            toastError('Cập nhật trạng thái thất bại')
            console.log(error);
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <Modal
            title="Cập nhật tài khoản IRIS"
            open={isOpen}
            onCancel={() => setIsOpen(false)}
            footer={[
                <Button onClick={handleUpdate} type="primary" disabled={!hasProviders}>
                    Cập nhật
                </Button>
            ]}
        >
            <Divider />
            <p><span style={{ color: 'red' }}>*</span> Chọn tài khoản IRIS</p>
            <Select
                style={{ width: '100%' }}
                value={accountValue}
                onChange={value => setAccountValue(value)}
                options={options}
                disabled={!hasProviders}
            />
            {!hasProviders && (
                <p style={{ color: '#ff4d4f', marginTop: 8 }}>
                    Không có tài khoản IRIS nào đang hoạt động.
                </p>
            )}
            <p><span style={{ color: 'red' }}>*</span> Nhập mã OTP xác nhận</p>
            <Input value={otpConfirm} onChange={e => setOtpConfirm(e.target.value)} />
            <Divider />
        </Modal>
    )
}
